// Configuración MSAL.js para autenticación contra Microsoft Entra ID
// App Registration: "Dashboard JMA AFAC"
// Tenant: JMA Seguridad
//
// IMPORTANTE: estos GUIDs son identificadores PÚBLICOS por diseño en flujos
// SPA con PKCE. No son secretos. La seguridad real proviene de:
//   1. Restricción de redirect URIs en la App Registration.
//   2. Lista blanca de usuarios autorizados (allowed-users.js).
//   3. Conditional Access y MFA del tenant.

export const msalConfig = {
  auth: {
    clientId: '2fc5ce98-2e59-409f-a67f-003dc8e70237',
    authority: 'https://login.microsoftonline.com/36ed694d-55ff-4bbf-9018-04037b362197',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return
        if (import.meta.env.DEV) {
          // eslint-disable-next-line no-console
          console.log(`[MSAL][${level}] ${message}`)
        }
      }
    }
  }
}

export const loginRequest = {
  scopes: [
    'User.Read',
    'Sites.Read.All',
    'Files.ReadWrite.All'
  ],
  // Forzar el selector de cuenta cada vez que se inicia sesión, incluso
  // con SSO activo. Franco y Jorge pueden tener varias cuentas M365 en el
  // navegador (corporativa, personal, otros tenants); queremos que elijan
  // explícitamente cuál usa el dashboard.
  //
  // IMPORTANTE: este prompt aplica sólo al flujo interactivo
  // (loginRedirect). La renovación silenciosa (acquireTokenSilent) NO lo
  // recibe — en auth-provider.js sólo se le pasan { account, scopes }, por
  // lo que mantiene la experiencia transparente al renovar tokens.
  prompt: 'select_account'
}

export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me'
}
